export default __webpack_public_path__ + "static/messaging-platform-question-formats-2-1280x434-6997fc2dba7bc80efea82d7c42c9d7b2.jpg";